import { useMutation } from "@tanstack/react-query";
import { Button, Divider, message } from "antd";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { OrderIcon } from "../../../assets/SVGs/SVGs";
import { addSale } from "../../../network/Sales";
import queryClient from "../../../services/react-query/queryClient";
import { client } from "../../../types/calendar";
import AddClient from "../../calendar/components/addAppointment/AddClient";
import PaymentMethod from "../../calendar/components/addAppointment/PaymentMethod";
import Tax from "../../calendar/components/addAppointment/Tax";
import TotalPrice from "../../calendar/components/addAppointment/TotalPrice";
import ListSoldProducts from "../ListSoldProducts";
import SelectProductSale from "../SelectProductSale";
import LastStep from "./Items/LastStep";

type Props = { close: any };

const ModalOrder = ({ close }: Props) => {
  const intl = useIntl();
  const [paymentMethod, setPaymentMethod] = useState<number | null>(null);
  const [idSale, setIdSale] = useState<number | null>(null);
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [tax, setTax] = useState<null | {
    id: number;
    name: string;
    tax_rate: number;
  }>(null);
  const [clientData, setClientData] = useState<client | null>(null);
  const [products, setProducts] = useState<any>([]);
  const { mutate: onAddSale, isLoading: isAddingSale } = useMutation(addSale, {
    onSuccess: (res: any) => {
      queryClient.invalidateQueries(["sales"]);
      if (res?.code === "ERR_BAD_REQUEST" || res?.code === "ERR_BAD_RESPONSE") {
        message.error(res?.response?.data?.message);
      } else {
        message.success("تمت العملية بنجاح");
        console.log(res, "resresresres");
        setIdSale(res.data?.data?.id);
        setCurrentStep((step) => step + 1);
      }
    },
    onError: (error) => {
      console.log(error, "as");
      message.error("Failed to add salon. Please try again.");
    },
  });
  const ItemsSale = products.map((e: any) => ({
    itemable_id: e?.id,
    itemable_type: e?.itemable_type,
    quantity: e?.quantity,
  }));
  const AddSaleBody = {
    client_profile_id: clientData?.id,
    type: "orders", //appointments,orders,memberships,gift_cards,all
    payment_method_id: paymentMethod, //cash, visa
    taxable_id: tax?.id,
    location_id: locationId,
    taxable_type: "tax",
    items: ItemsSale,
  };
  const buttonProps = (
    step: any
    // products: any
    //   setCurrentStep:any,
    //   isAddingSalon:any,
    //   AddSale:any,
    //   intl
  ) => {
    switch (step) {
      //   case 1:
      case 1:
        return {
          textId: "save",
          onClick: () => setCurrentStep(step + 1),
        };
      case 2:
        return {
          textId: "proceed_to_payment",
          onClick: () => setCurrentStep(step + 1),
        };
      case 3:
        return {
          textId: "confirm",
          onClick: () => setCurrentStep(step + 1),
        };
      case 4:
        return {
          textId: "done",
          onClick: () => {
            onAddSale(AddSaleBody);
          },
          //   loading: isAddingSalon,
        };
      default:
        return {
          textId: "save",
          onClick: () => {
            message.success("error");
          },
        };
    }
  };
  const { textId, onClick } = buttonProps(currentStep);
  return currentStep == 5 ? (
    <LastStep idSale={idSale} locationId={locationId} />
  ) : (
    <div className="mt-4">
      <div className="flex flex-col bg-[#FBFBFF] items-center justify-center w-full gap-3 py-3 rounded-lg">
        {OrderIcon}
        <h5 className="text-lg text-semibold">
          <FormattedMessage id="new_order" />
        </h5>
      </div>
      <Divider className=" bg-color-primary" />
      {currentStep === 1 || 2 || 3 ? (
        <>
          <AddClient clientData={clientData} setClientData={setClientData} />
          <Divider />
          <ListSoldProducts
            products={products}
            setProducts={setProducts}
            currentStep={currentStep}
          />

          {currentStep === 1 && (
            <div className="my-4">
              <SelectProductSale
                products={products}
                setProducts={setProducts}
              />
            </div>
          )}

          {currentStep > 1 && (
            <>
              <Divider className="bg-color-primary" />
              <div className="mb-4">
                <Tax setTax={setTax} tax={tax} />
              </div>
              <TotalPrice products={products} tax={tax} />
              {currentStep > 2 && (
                <PaymentMethod
                  isSelectedPaymentMethod={currentStep >= 4}
                  paymentMethod={paymentMethod}
                  setPaymentMethod={setPaymentMethod}
                />
              )}
            </>
          )}
        </>
      ) : null}
      <div className="flex items-center w-full gap-2 mt-8">
        <Button
          type="primary"
          className="w-full"
          htmlType="submit"
          disabled={products.length === 0}
          loading={isAddingSale}
          onClick={onClick}
        >
          {intl.formatMessage({ id: textId })}
        </Button>

        <Button
          type="primary"
          onClick={close}
          className="w-full btn-primary-not"
          htmlType="button"
        >
          {intl.formatMessage({ id: "cancel" })}
        </Button>
      </div>
    </div>
  );
};

export default ModalOrder;
